<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div id="container" class="apply_st">
        <div class="inner">
          <div v-on-clickaway="close" class="box_wrap">
            <div class="box tac">
              <div ref="focus" class="box_title">
                <h2 class="col_choice">대학교 선택</h2>
                <button class="close" @click="close">
                  <img src="@/assets/images/login_join/close.png" alt="닫기" />
                </button>
              </div>
              <div class="search_area">
                <form @submit.prevent="searchUnicols">
                  <legend class="blind">검색</legend>
                  <div class="search_box">
                    <label for="search-book" class="lab hidden">{{
                      $t('views.help.faq.2181')
                    }}</label>
                    <input
                      id="search-book"
                      v-model="searchNm"
                      type="text"
                      placeholder="대학교명을 입력하세요."
                      value="searchNm"
                      name="col_put"
                    />
                    <button
                      type="button"
                      class="btn_search"
                      @click="searchUnicols"
                    >
                      <span class="svg_search"></span
                      ><span class="blind">검색</span>
                    </button>
                  </div>
                  <p>
                    대학교 수정은 학교선택 시점으로부터 30일 후에 가능하니
                    정확히 입력해 주세요.
                  </p>
                </form>
              </div>
              <div class="uniList">
                <div class="pd_wrap">
                  <h3>
                    <span style="flex: 1;">대학교명</span>
                    <!-- <span style="flex: 3;">위치</span>
                    <span style="flex: 1;">연락처</span> -->
                  </h3>
                </div>
                <div class="scroll_wrap">
                  <EmptyData
                    v-if="getUnicolsList.length === 0"
                    data-tp="검색 결과"
                  />
                  <ul v-else ref="unicolBox">
                    <li
                      v-for="(shool, i) in getUnicolsList"
                      :key="i + 'arr'"
                      @click="requestUniv(shool)"
                    >
                      <span style="flex: 1;">
                        {{ shool.universityName || shool.unicolNm }}
                      </span>
                      <!-- <span style="flex: 3;">{{ shool.address }}</span>
                      <span style="flex: 1;">{{ shool.telNo }}</span> -->
                    </li>
                  </ul>
                </div>
              </div>
              <!-- <button class="box_btn save_btn" @click="close">선택완료</button> -->
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import EmptyData from '../common/EmptyData.vue'
// import axios from '@/store/axios'

export default {
  name: 'UnicoModal',
  components: { EmptyData },
  data() {
    return {
      searchNm: '',
      isShowModal: false,
      showErrorModal: false,
      currentPage: 1,
      applyPerPage: 10,
      set: '',
      inOnModal: false,
      className: '',
      classSem: '',
      classSchool: '',
      class: '',
      bookData: '',
      modalMsg: '',
      modalSubMsg: '',
      modalTitleTxt: '',
      isDigging: false
    }
  },
  computed: {
    ...mapGetters(['getUnicolsList', 'getUnicolsInfo', 'getUnicolsSearch'])
  },
  mounted() {
    this.searchUnicols()
  },
  destroyed() {
    this.$store.commit('resetPublish')
    // Object.assign(this.$data, this.$options.data.apply(this))
  },
  methods: {
    async moreSchools(e) {
      if (
        e.target.scrollHeight - 10 <=
          e.target.clientHeight + e.target.scrollTop &&
        this.isDigging === true
      ) {
        this.isDigging = false
        this.currentPage++
        await this.$store
          .dispatch('fetchUnicolsList', {
            searchNm: this.searchNm,
            pageRow: this.applyPerPage,
            pageNo: this.currentPage
          })
          .then((res) => {
            if (res.length === 10) {
              this.isDigging = true
            } else {
              this.isDigging = false
              return ''
            }
          })
      } else {
        return ''
      }
      // e.stopPropagation()
      // if (
      //   this.getUnicolsInfo.totalCount / this.applyPerPage <=
      //   this.currentPage
      // ) {
      //   return
      // }
      // if (
      //   this.$refs.unicolBox.scrollHeight - this.$refs.unicolBox.scrollTop ==
      //   this.$refs.unicolBox.clientHeight
      // ) {
      //   this.currentPage = this.currentPage + 1
      //   await this.$store.dispatch('fetchUnicolsList', {
      //     searchNm: this.searchNm,
      //     pageRow: this.applyPerPage,
      //     pageNo: this.currentPage
      //   })
      // }
    },
    async searchUnicols() {
      this.currentPage = 1
      this.$refs.unicolBox?.scrollTo && this.$refs.unicolBox.scrollTo(0, 0)
      this.isDigging = true
      try {
        await this.$store.dispatch('fetchUnicolsList', {
          searchNm: this.searchNm,
          pageRow: this.applyPerPage,
          pageNo: this.currentPage
        })
      } catch (err) {
        console.log(err)
      }
    },
    requestUniv(school) {
      if (school.universitySeq) {
        // universitySeq가 존재하면 무조건 기존 unicolCd를 대체
        school.unicolCd = school.universitySeq
      }

      if (school.universityName) {
        // universityName이 존재하면 기존 unicolNm을 대체
        school.unicolNm = school.universityName
      }
      this.$emit('unicolInfo', school)
    },
    closeModal() {
      this.isShowModal = false
      this.showErrorModal = false
    },

    toggleErrorModal() {
      this.modalTitleTxt = '알림창'
      this.showErrorModal = !this.showErrorModal
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style src="@/assets/css/meta_book_style.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
input {
  outline: none;
}
// 학지추가
.uniList ul::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  border-radius: 10px;
  background: #f0f5fa;
}
.uniList ul::-webkit-scrollbar-thumb {
  width: 5px;
  height: 10px;
  background-color: #0f638f;
  border-radius: 10px;
}
.input_t_wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0px 12px;
}
.t_20 {
  top: 20% !important;
}
// 학지추가
h2 {
  color: $h_BLUE_01;
}
.search_area {
  width: 100%;
  margin: 0 auto;
  line-height: 48px;
  border-radius: 12px;

  .search_box {
    background: #f0f5fa;
    width: 100%;
    height: 56px;
    border-radius: 12px;
    margin: 0 auto;
    input {
      width: 100%;
      padding: 0 24px;
      height: 100%;
      margin: 0 auto;
      border-radius: 12px;
      background-color: inherit;
      font-size: 15px;
    }
    input::placeholder {
      color: $h_BLUE_01;
    }
  }
  p {
    margin-top: 16px;
    padding-left: 15px;
    text-align: left;
    font-size: 15px;
    color: #1f53cc;
  }
}
// .section .inner {
//   padding: 132px 0 124px;
// }
#container {
  min-height: auto;
}
.apply_st {
  width: 100% !important;
  .inner {
    padding: 0;
    .close_btn {
      right: 7%;
    }
    .box_wrap {
      padding-bottom: 89px;
      width: 100%;
      max-width: 520px;
      margin: 0 auto;
      .box {
        width: 100%;
        max-width: 520px;
      }
    }
  }
  .btn_wrap .box_btn {
    width: 150px;
  }
}
.uniList {
  width: 100%;
  border-top: 1px solid $h_BLUE_01;
  margin: 25px 0;
  h3 {
    height: 60px;
    display: flex;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 1.2em;
      line-height: 23px;
      flex: 2;
    }
  }
  ul {
    max-height: 46vh;
    overflow: auto;
    li:first-child {
      border-top: 1px solid #d6e7f1;
    }
    li {
      border-bottom: 1px solid #d6e7f1;
      height: 60px;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        font-size: 1em;
        flex: 2;
      }

      span:nth-child(2) {
        flex: 2;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span:nth-child(3) {
        flex: 2;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.apply_formlist {
  text-align: left;
  margin-bottom: 60px;
}
.apply_formlist .form_wrap li {
  padding-left: 148px;
  position: relative;
}
.apply_formlist .form_wrap li:first-child input {
  width: calc(100% - 120px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.apply_formlist .form_wrap li input {
  width: 100%;
}
.apply_formlist .form_wrap li p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: -0.03em;
  height: 22px;
}
.svg_search {
  margin: 0 !important;
}
.book_search {
  width: 112px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  background: #67788a;
  color: #fff;
  font-size: 16px;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  position: absolute;
  right: 0;
  top: 0;
}
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  padding-top: 83px;
  padding-bottom: 8px;
  display: block;
  //   background: url(../../assets/images/pop_msg/msg_pod2.png) no-repeat top center;
}
.ly_alert .ly_inner p {
  color: #627283;
  font-size: 16px;
  margin-top: 0;
  letter-spacing: -0.03em;
  word-break: keep-all;
}
.ly_alert .ly_inner .btnWrap {
  margin-top: 24px;
}
#container {
  min-width: 330px;
}
.box_wrap {
  .box_title {
    position: relative;
    margin-bottom: 23px;
    h2.col_choice {
      font-size: 20px;
      color: #000000;
      padding-right: 20px;
      letter-spacing: 0;
    }
  }
}
.uniList {
  margin: 20px 0;
  border-top: none;
  .pd_wrap {
    padding-right: 20px;
    h3 {
      height: 44px;
      background-color: #f6f6f6;
      border-top: 1px solid #000000;
      span {
        font-size: 15px;
        font-weight: 400;
        color: #777777;
      }
    }
  }
  .scroll_wrap {
    padding-right: 5px;
    ul {
      padding-right: 10px;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #555555;
      }
      li {
        padding: 0;
        gap: 16px;
        border-bottom: 1px solid #e8e8e8;
        height: 56px;
        &:nth-child(1) {
          border-top: 1px solid #e8e8e8;
        }
        span {
          font-size: 13px;
          letter-spacing: 0;
          font-family: 'pretendard-medium';
          line-height: 20px;
          &:nth-child(1) {
            color: #333333;
          }
          &:nth-child(2) {
            white-space: normal;
            color: #777777;
          }
        }
      }
    }
  }
}
.search_area {
  padding-right: 20px;
  .search_box {
    position: relative;
    background-color: transparent;
    // border: 1px solid #dddddd;
    border-radius: 8px;
    .btn_search {
      top: 50%;
      transform: translateY(-50%);
      right: 16px;
      .svg_search {
        background-image: url('../../assets/images/login_join/ic_search.png');
        background-size: cover;
      }
    }
    input[name='col_put'] {
      border: 1px solid #dddddd;
      color: #333333;
      padding: 0 16px;
      letter-spacing: 0;
      &::placeholder {
        color: #999999;
      }
      &:focus {
        border: 1px solid #008df3;
      }
    }
  }
}
.apply_st {
  .inner {
    .box_wrap {
      padding: 20px 0 20px 20px !important;
      .close {
        position: absolute;
        width: 17px;
        height: 17px;
        top: 5px;
        right: 20px;
        > img {
          width: 100%;
        }
      }
      .save_btn {
        width: 100%;
        height: 56px;
        background: #008df3;
        border-radius: 12px;
        border: none;
        font-family: 'pretendard-light';
        font-weight: 600;
        font-size: 18px;
        line-height: 56px;
        color: #fff;
      }
    }
  }
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
  //   .apply_st .box_wrap,
  //   .apply_st .box_wrap .box {
  //     width: 100%;
  //   }
  //   #container {
  //     min-height: auto !important;
  //   }
  //   .section .inner {
  //     padding: 20px 0;
  //   }
  //   .apply_st .box_wrap {
  //     padding: 50px 0;
  //     border-radius: 0;
  //   }
}
@media (max-width: 767px) {
  .box_wrap {
    padding: 20px 0 !important;
    .box_title {
      margin-bottom: 1.35em;
    }
  }
  .uniList ul li {
    padding: 0 10px;
  }
  h3,
  li {
    span:nth-child(3) {
      display: none;
    }
  }
  //   .apply_formlist .form_wrap li {
  //     padding-left: 68px;
  //   }
  //   .apply_formlist .form_wrap li:first-child input {
  //     width: calc(100% - 80px);
  //   }
  //   .book_search {
  //     width: 70px;
  //   }
}
@media (max-width: 480px) {
  .scroll_wrap {
    ul {
      li {
        span {
          &:nth-child(1) {
            color: #333333;
          }
          &:nth-child(2) {
            white-space: normal;
            color: #777777;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
